import { FC } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { Trans } from "~/utils/i18next";

export const Description: FC = () => {
  return (
    <Flex justify="center" px={2} textAlign="center" w="full">
      <Text maxW="30.875rem" variant="th-body1">
        <Trans i18nKey="onboarding.someLogisticsPage.description" />
      </Text>
    </Flex>
  );
};
